export default __webpack_public_path__ + "static/media/img-ovato-mascot.b9c8e72f.jpg";